import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import * as FormActions from '../../store/form/actions';
import { useTranslation } from '../../i18n';
import { Title, Button, ImageHome, Container } from './styles';
import 'react-toastify/dist/ReactToastify.css';
var InitialPage = function () {
    var location = useLocation();
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var searchParams = useSearchParams()[0];
    var _a = React.useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useSelector(function (state) { return state.form; }), form = _b.form, formInfo = _b.formInfo;
    var state = location.state;
    window.onpopstate = function () {
        var _a;
        console.log("initial page -> onpopstate");
        var url = new URL(window.location.href);
        var origin = url.origin;
        var product = origin.replace(".idcerberus.com", "").replace("-dev", "").replace("https://", "").replace("http://", "").split("/")[0];
        if (origin.includes("sdk") || origin.includes('localhost') || origin.includes('192.168')) {
            product = searchParams.get('product');
        }
        if (product && url.search !== '')
            navigate('/form', { state: { clientId: product, redirect: (_a = searchParams.get('redirect')) !== null && _a !== void 0 ? _a : false } });
    };
    window.onload = function () {
        var _a;
        console.log("initial page -> onload");
        var url = new URL(window.location.href);
        var origin = url.origin;
        var product = origin.replace(".idcerberus.com", "").replace("-dev", "").replace("https://", "").replace("http://", "").split("/")[0];
        if (origin.includes("sdk") || origin.includes('localhost') || origin.includes('cloudfront') || origin.includes('192.168')) {
            product = searchParams.get('product');
        }
        if (product && url.search !== '')
            navigate('/form', { state: { clientId: product, redirect: (_a = searchParams.get('redirect')) !== null && _a !== void 0 ? _a : false } });
    };
    var openOnboarding = function (productName, tokenOnboarding, serviceAlias, fieldAlias, countSteps) {
        var _a;
        navigate('/form', {
            state: {
                clientId: productName.toLocaleLowerCase() || 'app-cerberus-liveness',
                tokenOnboarding: tokenOnboarding,
                serviceAlias: serviceAlias,
                fieldAlias: fieldAlias,
                countSteps: countSteps,
                redirect: (_a = searchParams.get('redirect')) !== null && _a !== void 0 ? _a : false
            }
        });
    };
    var restartOnboarding = function () {
        var _a;
        if (state.tokenOnboarding && state.serviceAlias && state.countSteps) {
            openOnboarding(state.productName, state.tokenOnboarding, state.serviceAlias, null, state.countSteps);
        }
        else {
            navigate("?product=".concat(state.productName), { replace: true, state: { redirect: (_a = searchParams.get('redirect')) !== null && _a !== void 0 ? _a : false } });
        }
    };
    var resetLocation = function () {
        navigate(location.pathname, {});
    };
    React.useEffect(function () {
        window.addEventListener('beforeunload', resetLocation);
        return function () { return window.removeEventListener('beforeunload', resetLocation); };
    }, []);
    React.useEffect(function () {
        if (form && formInfo) {
            if (state && state.errorMessage) {
                toast.error(state.errorMessage, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                });
            }
            dispatch(FormActions.resetFormState());
        }
    }, []);
    React.useEffect(function () {
        console.log("initial page -> useEffect 1");
        localStorage.removeItem('tokenOnboarding');
        var url = new URL(window.location.href);
        var origin = url.origin;
        var product = origin.replace(".idcerberus.com", "").replace("-dev", "").replace("-hml", "").replace("https://", "").replace("http://", "").split("/")[0];
        if (origin.includes("sdk") || origin.includes('localhost') || origin.includes('192.168')) {
            if (searchParams.get('product')) {
                openOnboarding(searchParams.get('product'), searchParams.get('token') || searchParams.get('tokenOnboarding'), searchParams.get('serviceAlias'), searchParams.get('fieldAlias'), null);
            }
            setLoading(false);
        }
        else {
            openOnboarding(product, searchParams.get('token') || searchParams.get('tokenOnboarding'), searchParams.get('serviceAlias'), searchParams.get('fieldAlias'), null);
        }
    }, []);
    return (React.createElement(Container, null,
        React.createElement(ToastContainer, null),
        !loading ? (React.createElement(React.Fragment, null,
            React.createElement(Title, null, t('initial.noConfiguration')),
            React.createElement(ImageHome, { src: "/images/imageHome.svg", alt: t('initial.initialImageAlt') }),
            (state && state.productName) && (React.createElement(Button, { onClick: restartOnboarding }, t('initial.tryAgain'))),
            React.createElement(Title, null, t('initial.version', { version: '0.2.5' })))) : React.createElement(React.Fragment, null)));
};
export default InitialPage;
